module.exports = __webpack_public_path__ + "static/media/aws_development.30b35f40.svg";